import { useCallback, useMemo } from "react";
import { notificationParametersType } from "../lib";
import { SelectDS, Spacer } from "@qivia/ui";
import { NotificationListType } from "../notificationsApi";
import {
  selectEmailSubscriptionsList,
  selectPlatformSubscriptionsList,
  updateCompanySubscriptionsParametersAsync,
} from "../notificationsSlice";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany } from "../../homeSlice";

export default function ParametersSelect({
  notif,
  parameters,
  onChange,
}: {
  notif: NotificationListType;
  parameters: Record<string, Record<string, unknown> | null>;
  onChange: (value?: Record<string, unknown>) => void;
}) {
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const platformSubscriptionsList = useAppSelector(
    selectPlatformSubscriptionsList,
  );
  const emailSubscriptionsList = useAppSelector(selectEmailSubscriptionsList);

  const subscriptionParameters: Record<string, unknown> | null = useMemo(() => {
    const platformSubscriptionParameters = platformSubscriptionsList?.find(
      (subscription) => subscription.type === notif.type,
    )?.parameters;

    const emailSubscriptionParameters = emailSubscriptionsList?.find(
      (subscription) => subscription.type === notif.type,
    )?.parameters;

    if (
      platformSubscriptionParameters &&
      Object.keys(platformSubscriptionParameters).length > 0
    ) {
      return platformSubscriptionParameters;
    }

    if (
      emailSubscriptionParameters &&
      Object.keys(emailSubscriptionParameters).length > 0
    ) {
      return emailSubscriptionParameters;
    }

    return null;
  }, [platformSubscriptionsList, emailSubscriptionsList, notif.type]);

  const handleChangeParameter = useCallback(
    (parameter: string, value?: string) => {
      if (!company || !value) {
        return;
      }

      const newParametersValue = {
        [parameter]: value,
      };

      onChange({
        ...parameters[String(notif.type)],
        ...newParametersValue,
      });

      void dispatch(
        updateCompanySubscriptionsParametersAsync({
          type: notif.type,
          company: company.uuid,
          parameters: newParametersValue,
        }),
      );
    },
    [company, notif.type, onChange, parameters, dispatch],
  );

  if (!notif.parameters) return null;

  return notificationParametersType[String(notif.type)]?.map(
    (parameterType) =>
      notif.parameters && (
        <div key={parameterType}>
          <SelectDS
            label=""
            width={4}
            placeholder="limit"
            menuListMaxHeight={10}
            options={notif.parameters[parameterType].map((value) => ({
              value: String(value),
              label: String(value),
              disabled: value === subscriptionParameters?.[parameterType],
            }))}
            onChange={(parameterValueOfType) => {
              handleChangeParameter(parameterType, parameterValueOfType?.value);
            }}
            disabled={!subscriptionParameters}
            value={{
              value: String(
                subscriptionParameters?.[parameterType] ??
                  notif.defaultParameters?.[parameterType],
              ),
              label:
                String(
                  subscriptionParameters?.[parameterType] ??
                    notif.defaultParameters?.[parameterType],
                ) + " h", //TODO HANDLE THE UNIT OF THE PARAMETER
            }}
            withoutSpacerBottom
          />
          <Spacer x={1} />
        </div>
      ),
  );
}
